import { useEffect } from 'react';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';
/**
 *
 * A wrapper for popups to signal popupOpen user intent
 */
export var UserIntentPopupWrapper = function UserIntentPopupWrapper(_ref) {
  var _ref$userIntent = _ref.userIntent,
    userIntent = _ref$userIntent === void 0 ? 'popupOpen' : _ref$userIntent,
    children = _ref.children,
    api = _ref.api;
  useEffect(function () {
    var _api$userIntent;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.commands.setCurrentUserIntent(expValEqualsNoExposure('platform_editor_lovability_user_intent', 'isEnabled', true) ? userIntent : 'popupOpen'));
    return function () {
      var _api$userIntent2;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.commands.setCurrentUserIntent('default'));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return children;
};